import { keyframes } from "tss-react"
import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../../../mp-core/themes/palette"

const rotation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const useStyles = makeStyles()(({ spacing }) => ({
  globalSearchLoadingContainer: {
    padding: spacing(5),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "3px",
    backgroundColor: blueGrey[50]
  },
  globalSearchLoadingCircle: {
    animation: `${rotation} 2s linear infinite`
  }
}))
